import { useMemo } from 'react';
import { SearchType } from '../assistantSearchTypes';
import { assistantHasResult } from '../helpers/resultHelper';
import { useFilteredNavigationResults } from '../drawer/results/navigation/useFilteredNavigationResults';
import { getMergeSearchResultAndNavigation } from '../drawer/results/mergeSearchResultHelper';
import { useAssistantSearchResultListMap } from '../drawer/hooks/useAssistantSearchResultListMap';
import { AssistantResult } from '../query/useAssistantSearchQuery';
import { FilterStateProps } from '../Assistant';

interface AssistantSearchResultComponentsProps {
    assistantResult?: AssistantResult;
    searchTerm: string;
    filterState: FilterStateProps;
}

export const useAssistantResultDetails = ({
    assistantResult,
    searchTerm,
    filterState,
}: AssistantSearchResultComponentsProps) => {
    const navigations = useFilteredNavigationResults(searchTerm);
    const mergedSearchResultWithResultType = useMemo(
        () => getMergeSearchResultAndNavigation(assistantResult?.searchResult, navigations),
        [assistantResult?.searchResult, navigations]
    );
    const assistantSearchResultListMap = useAssistantSearchResultListMap(
        mergedSearchResultWithResultType,
        searchTerm,
        filterState
    );

    return useMemo(() => {
        const hasResult = !!assistantResult && assistantHasResult(assistantResult, mergedSearchResultWithResultType);
        const availableSearchTypeKeyList: Array<SearchType> = [];
        Object.keys(assistantSearchResultListMap).forEach((key) => {
            if (assistantSearchResultListMap[key as SearchType]?.length > 0) {
                availableSearchTypeKeyList.push(key as SearchType);
            }
        });

        return {
            hasResult,
            assistantSearchResultListMap,
            availableSearchTypeKeyList,
        };
    }, [assistantResult, assistantSearchResultListMap, mergedSearchResultWithResultType]);
};
